import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';

export const adminGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const user = auth.getUser();
  if (!user) {
    auth.login();
    return false;
  }
  if (user.roles.includes('admin')) return true;
  return router.createUrlTree(['/dashboard']);
};
